const mutations = {
  SET_SKILLS: (state, payload) => {
    state.skills = payload;
  },
  SET_SKILLS_LOADING: (state, payload) => {
    state.skillsLoading = payload;
  },
  SET_SKILL_ACTION_LOADING: (state, payload) => {
    state.skillActionLoading = payload;
  },
  PUSH_TO_SKILLS: (state, payload) => {
    state.skills.push(payload);
  },
  UPDATE_SKILL: (state, payload) => {
    const index = state.skills.findIndex(skill => skill.id === payload.id);
    if (index !== -1) {
      state.skills.splice(index, 1, payload);
    }
  },
  DELETE_SKILL: (state, skillId) => {
    state.skills = state.skills.filter(
      skill => skill.id !== skillId
    );
  },
};

export default mutations;